import { PageCode } from '../definitions/codes';

export const isPageCode = (code: string): code is PageCode =>
	Object.values(PageCode).includes(code as PageCode);
